@if (shouldDisplay()) {
  <div class="paginator-wrapper">
    <button
      data-testid="paginator-previous-btn"
      class="pager"
      title="Précédent"
      (click)="previousPage()"
      [disabled]="!hasPreviousPage()"
    >
      <mat-icon inline="true" fontIcon="icon-ic-arrow-left-2" />
    </button>
    <span data-testid="paginator-display">{{ pagerDisplay() }}</span>
    <button
      data-testid="paginator-next-btn"
      class="pager"
      title="Suivant"
      (click)="nextPage()"
      [disabled]="!hasNextPage()"
    >
      <mat-icon inline="true" fontIcon="icon-ic-arrow-right-2" />
    </button>
  </div>
}
